









import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'normal',
      validator: val => ['small', 'normal', 'large'].includes(val),
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
    padded: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {}
  },
})
